// ═══════════════ NSW SUBURBS DATABASE ═══════════════
// Comprehensive list of suburbs, towns and localities in New South Wales
// Grouped by region for reference but exported as a flat sorted array

const SYDNEY_METRO = [
  // Sydney CBD & Inner
  'Barangaroo','Chippendale','Darling Harbour','Darlinghurst','Dawes Point','Elizabeth Bay',
  'Glebe','Haymarket','Millers Point','Newtown','Paddington','Potts Point','Pyrmont',
  'Redfern','Rushcutters Bay','Surry Hills','Sydney CBD','The Rocks','Ultimo','Woolloomooloo',

  // Eastern Suburbs
  'Bellevue Hill','Bondi','Bondi Beach','Bondi Junction','Bronte','Centennial Park',
  'Clovelly','Coogee','Darling Point','Double Bay','Dover Heights','Edgecliff',
  'Elizabeth Bay','Kensington','Kingsford','Malabar','Maroubra','Matraville',
  'Moore Park','North Bondi','Paddington','Point Piper','Queens Park','Randwick',
  'Rose Bay','South Coogee','Tamarama','Vaucluse','Waverley','Watsons Bay',

  // Inner West
  'Abbotsford','Annandale','Ashbury','Ashfield','Balmain','Balmain East','Birchgrove',
  'Breakfast Point','Burwood','Burwood Heights','Cabarita','Camperdown','Canada Bay',
  'Canterbury','Concord','Concord West','Croydon','Croydon Park','Dulwich Hill',
  'Earlwood','Enfield','Enmore','Erskineville','Five Dock','Forest Lodge','Haberfield',
  'Homebush','Homebush West','Hurlstone Park','Leichhardt','Lewisham','Liberty Grove',
  'Lilyfield','Marrickville','Mortlake','Newtown','North Strathfield','Petersham',
  'Rhodes','Rodd Point','Rozelle','Russell Lea','St Peters','Stanmore','Strathfield',
  'Strathfield South','Summer Hill','Sydenham','Tempe','Wareemba',

  // North Shore Lower
  'Artarmon','Cammeray','Castle Cove','Castlecrag','Chatswood','Chatswood West',
  'Cremorne','Cremorne Point','Crows Nest','Kirribilli','Lane Cove','Lane Cove North',
  'Lane Cove West','Lavender Bay','Longueville','McMahons Point','Middle Cove',
  'Milsons Point','Mosman','Naremburn','Neutral Bay','North Sydney','Northbridge',
  'Riverview','St Leonards','Waverton','Willoughby','Willoughby East','Wollstonecraft',

  // North Shore Upper
  'East Killara','East Lindfield','Gordon','Killara','Lindfield','Pymble',
  'Roseville','Roseville Chase','South Turramurra','St Ives','St Ives Chase',
  'Turramurra','Wahroonga','Warrawee','West Pymble',

  // Northern Beaches
  'Allambie Heights','Avalon Beach','Balgowlah','Balgowlah Heights','Bayview',
  'Beacon Hill','Belrose','Bilgola Beach','Bilgola Plateau','Brookvale','Church Point',
  'Clontarf','Collaroy','Collaroy Plateau','Cromer','Curl Curl','Davidson','Dee Why',
  'Elanora Heights','Fairlight','Forestville','Frenchs Forest','Freshwater',
  'Ingleside','Killarney Heights','Manly','Manly Vale','Mona Vale','Narrabeen',
  'Narraweena','Newport','North Balgowlah','North Curl Curl','North Manly',
  'North Narrabeen','Oxford Falls','Palm Beach','Queenscliff','Seaforth',
  'Terrey Hills','Warriewood','Whale Beach',

  // Hills District
  'Baulkham Hills','Beaumont Hills','Bella Vista','Box Hill','Castle Hill',
  'Cherrybrook','Dural','Galston','Glenhaven','Glenwood','Kellyville',
  'Kellyville Ridge','Kenthurst','North Kellyville','North Rocks','Norwest',
  'Rouse Hill','Round Corner','Stanhope Gardens','The Ponds','West Pennant Hills',
  'Winston Hills',

  // Hornsby/Ku-ring-gai
  'Asquith','Beecroft','Berowra','Berowra Heights','Brooklyn','Cheltenham',
  'Cowan','Galston','Hornsby','Hornsby Heights','Mount Colah','Mount Kuring-gai',
  'Normanhurst','Pennant Hills','Thornleigh','Wahroonga','Waitara','Westleigh',

  // Parramatta & West
  'Camellia','Carlingford','Constitution Hill','Dundas','Dundas Valley','Eastwood',
  'Epping','Ermington','Granville','Harris Park','Marsfield','Meadowbank',
  'Melrose Park','Merrylands','Newington','North Parramatta','Northmead',
  'Old Toongabbie','Olympic Park','Oatlands','Parramatta','Rosehill','Rydalmere',
  'South Granville','South Wentworthville','Telopea','Toongabbie','Wentworthville',
  'Westmead','Wentworth Point',

  // Blacktown Area
  'Acacia Gardens','Arndell Park','Bidwill','Blackett','Blacktown','Bungarribee',
  'Colebee','Dean Park','Dharruk','Doonside','Emerton','Glendenning','Hassall Grove',
  'Hebersham','Huntingwood','Kings Langley','Kings Park','Lalor Park','Lethbridge Park',
  'Marsden Park','Marayong','Minchinbury','Mount Druitt','Oakhurst','Plumpton',
  'Prospect','Quakers Hill','Riverstone','Rooty Hill','Schofields','Seven Hills',
  'Shalvey','Shanes Park','The Ponds','Tregear','Whalan','Willmot','Woodcroft',

  // South Sydney
  'Alexandria','Arncliffe','Banksia','Beaconsfield','Botany','Daceyville','Eastgardens',
  'Eastlakes','Green Square','Hillsdale','Mascot','Pagewood','Rosebery','Waterloo','Zetland',

  // St George Area
  'Allawah','Bexley','Bexley North','Beverly Hills','Blakehurst','Carlton','Connells Point',
  'Hurstville','Hurstville Grove','Kingsgrove','Kogarah','Kogarah Bay','Kyle Bay',
  'Lugarno','Mortdale','Narwee','Oatley','Peakhurst','Peakhurst Heights',
  'Penshurst','Ramsgate','Ramsgate Beach','Riverwood','Rockdale','Sans Souci',
  'South Hurstville','Wolli Creek',

  // Sutherland Shire
  'Alfords Point','Bangor','Bonnet Bay','Bundeena','Caringbah','Caringbah South',
  'Como','Cronulla','Engadine','Grays Point','Gymea','Gymea Bay','Heathcote',
  'Illawong','Jannali','Kangaroo Point','Kareela','Kirrawee','Lilli Pilli','Loftus',
  'Lucas Heights','Maianbar','Menai','Miranda','Oyster Bay','Royal National Park',
  'Sandy Point','Sutherland','Sylvania','Sylvania Waters','Taren Point','Waterfall',
  'Woolooware','Woronora','Woronora Heights','Yarrawarrah',

  // Canterbury-Bankstown
  'Bankstown','Bass Hill','Belfield','Belmore','Birrong','Campsie','Canterbury',
  'Chester Hill','Chullora','Clemton Park','Condell Park','East Hills','Georges Hall',
  'Greenacre','Kingsgrove','Lakemba','Lansdowne','Milperra','Mount Lewis',
  'Narwee','Padstow','Padstow Heights','Panania','Punchbowl','Revesby',
  'Revesby Heights','Roselands','Sefton','Villawood','Wiley Park','Yagoona',

  // Liverpool & Fairfield
  'Abbotsbury','Auburn','Austral','Bonnyrigg','Bonnyrigg Heights','Bossley Park',
  'Cabramatta','Cabramatta West','Canley Heights','Canley Vale','Carramar',
  'Cecil Park','Chipping Norton','Edensor Park','Fairfield','Fairfield East',
  'Fairfield Heights','Fairfield West','Green Valley','Greenfield Park','Guildford',
  'Guildford West','Hammondville','Holsworthy','Hinchinbrook','Hoxton Park',
  'Lansdowne','Leppington','Liverpool','Lurnea','Merrylands','Merrylands West',
  'Miller','Moorebank','Mount Pritchard','Old Guildford','Prairiewood',
  'Prestons','Smithfield','Smithfield West','Wakeley','Warwick Farm',
  'Wetherill Park','Yennora',

  // Campbelltown & Macarthur
  'Airds','Ambarvale','Blair Athol','Bow Bowing','Bradbury','Campbelltown','Claymore',
  'Eagle Vale','Eschol Park','Glen Alpine','Ingleburn','Kearns','Leumeah',
  'Long Point','Macquarie Fields','Minto','Minto Heights','Mount Annan','Narellan',
  'Narellan Vale','Oran Park','Raby','Rosemeadow','Ruse','Spring Farm',
  'St Andrews','St Helens Park','Varroville','Wedderburn','Woodbine',

  // Penrith & Blue Mountains Fringe
  'Agnes Banks','Berkshire Park','Cambridge Gardens','Cambridge Park','Castlereagh',
  'Claremont Meadows','Colyton','Cranebrook','Emu Heights','Emu Plains','Glenbrook',
  'Glenmore Park','Jamisontown','Jordan Springs','Kingswood','Leonay','Llandilo',
  'Londonderry','Luddenham','Mount Riverview','Mulgoa','Orchard Hills','Oxley Park',
  'Penrith','Regentville','South Penrith','St Clair','St Marys','Wallacia',
  'Warragamba','Werrington','Werrington County','Werrington Downs','Yellow Rock',

  // Hawkesbury
  'Bligh Park','Clarendon','Freemans Reach','Glossodia','Hobartville','Kurmond',
  'McGraths Hill','North Richmond','Pitt Town','Richmond','South Windsor',
  'Vineyard','Windsor','Wilberforce',

  // Ryde & Macquarie Park
  'Chatswood West','Denistone','Denistone East','Denistone West','East Ryde',
  'Gladesville','Henley','Hunters Hill','Macquarie Park','Marsfield',
  'Meadowbank','Melrose Park','North Ryde','Putney','Ryde','Tennyson Point',
  'Top Ryde','West Ryde','Woolwich',

  // Camden & Wollondilly
  'Camden','Camden South','Cawdor','Cobbitty','Currans Hill','Douglas Park',
  'Elderslie','Ellis Lane','Grasmere','Gregory Hills','Harrington Park',
  'Menangle','Menangle Park','Mount Hunter','Oakdale','Oran Park','Picton',
  'Spring Farm','Tahmoor','The Oaks','Thirlmere','Wilton',
];

const CENTRAL_COAST = [
  'Avoca Beach','Bateau Bay','Berkeley Vale','Blue Bay','Booker Bay','Budgewoi',
  'Buff Point','Canton Beach','Chain Valley Bay','Chittaway Bay','Chittaway Point',
  'Copacabana','Davistown','Erina','Ettalong Beach','Forresters Beach','Gorokan',
  'Gosford','Green Point','Hardys Bay','Holgate','Kariong','Killarney Vale',
  'Killcare','Killcare Heights','Kincumber','Lake Haven','Lake Munmorah','Lisarow',
  'Long Jetty','MacMasters Beach','Matcham','Narara','Niagara Park','Noraville',
  'North Gosford','Ourimbah','Pearl Beach','Phegans Bay','Point Clare','Point Frederick',
  'Pretty Beach','Saratoga','Shelly Beach','Somersby','Springfield','Tascott',
  'Terrigal','The Entrance','Toowoon Bay','Tuggerah','Tumbi Umbi','Umina Beach',
  'Wamberal','Watanobbi','Woy Woy','Wyoming','Wyong',
];

const BLUE_MOUNTAINS = [
  'Blaxland','Bullaburra','Faulconbridge','Glenbrook','Hazelbrook','Katoomba',
  'Lapstone','Lawson','Leura','Linden','Medlow Bath','Mount Victoria',
  'Springwood','Valley Heights','Warrimoo','Wentworth Falls','Winmalee','Woodford',
  'Yellow Rock',
];

const ILLAWARRA_SHOALHAVEN = [
  'Albion Park','Albion Park Rail','Austinmer','Barrack Heights','Berkeley','Bomaderry',
  'Bulli','Calderwood','Clifton','Coledale','Coniston','Corrimal','Dapto',
  'Fairy Meadow','Figtree','Flinders','Gerringong','Helensburgh','Horsley',
  'Jamberoo','Keiraville','Kiama','Mangerton','Minnamurra','Mount Keira',
  'Mount Ousley','Mount Pleasant','North Wollongong','Nowra','Oak Flats',
  'Port Kembla','Scarborough','Shell Cove','Shellharbour','Stanwell Park',
  'Thirroul','Towradgi','Unanderra','Warilla','Warrawong','Windang',
  'Wollongong','Woonona',
];

const HUNTER_VALLEY = [
  'Adamstown','Bar Beach','Barnsley','Beresfield','Blackalls Park','Bolton Point',
  'Boolaroo','Branxton','Broadmeadow','Cameron Park','Cardiff','Cessnock',
  'Charlestown','Cooks Hill','East Maitland','Edgeworth','Elermore Vale',
  'Fletcher','Glendale','Hamilton','Hamilton South','Hexham','Islington',
  'Jesmond','Kahibah','Kotara','Kurri Kurri','Lambton','Lorn','Maitland',
  'Maryland','Mayfield','Merewether','Minmi','Morisset','Morpeth','Nelson Bay',
  'New Lambton','Newcastle','Newcastle East','Newcastle West','North Lambton',
  'Pokolbin','Raymond Terrace','Rutherford','Salamander Bay','Sandgate',
  'Singleton','Stockton','Teralba','The Hill','The Junction','Tighes Hill',
  'Toronto','Wallsend','Warabrook','Waratah','Warners Bay','Wickham',
];

const NORTH_COAST = [
  'Alstonville','Ballina','Bangalow','Bellingen','Byron Bay','Casino','Coffs Harbour',
  'Corindi Beach','Dorrigo','Evans Head','Forster','Grafton','Iluka','Kempsey',
  'Lennox Head','Lismore','Macksville','Maclean','Mullumbimby','Murwillumbah',
  'Nambucca Heads','Ocean Shores','Port Macquarie','Raymond Terrace',
  'Sawtell','South West Rocks','Suffolk Park','Taree','Tuncurry','Tweed Heads',
  'Tweed Heads South','Urunga','Woolgoolga','Yamba',
];

const SOUTH_COAST = [
  'Batemans Bay','Bega','Bermagui','Berry','Bomaderry','Broulee','Callala Bay',
  'Culburra Beach','Eden','Huskisson','Jervis Bay','Kiama','Merimbula','Milton',
  'Mollymook','Moruya','Narooma','Nowra','Pambula','Sanctuary Point',
  'Shoalhaven Heads','Sussex Inlet','Tathra','Ulladulla','Vincentia','Worrigee',
];

const NEW_ENGLAND_NW = [
  'Armidale','Glen Innes','Gunnedah','Guyra','Inverell','Moree','Narrabri',
  'Quirindi','Tamworth','Tenterfield','Uralla','Walcha','Walgett','Warialda',
];

const CENTRAL_WEST = [
  'Bathurst','Blayney','Condobolin','Cowra','Dubbo','Forbes','Lithgow','Mudgee',
  'Oberon','Orange','Parkes','Peak Hill','Portland','Wellington',
];

const RIVERINA_MURRAY = [
  'Albury','Balranald','Corowa','Deniliquin','Finley','Griffith','Hay',
  'Jerilderie','Junee','Leeton','Narrandera','Temora','Tumbarumba','Tumut',
  'Wagga Wagga','West Wyalong','Young',
];

const SOUTHERN_HIGHLANDS_TABLELANDS = [
  'Berrima','Bowral','Braidwood','Bundanoon','Cooma','Crookwell','Goulburn',
  'Mittagong','Moss Vale','Queanbeyan','Robertson','Wentworth Falls','Yass',
];

const FAR_WEST = [
  'Bourke','Brewarrina','Broken Hill','Cobar','Lightning Ridge','Menindee',
  'Nyngan','Tibooburra','Wentworth','White Cliffs','Wilcannia',
];

// ═══════════════ COMBINED & SORTED ═══════════════
const NSW_SUBURBS = [
  ...new Set([
    ...SYDNEY_METRO,
    ...CENTRAL_COAST,
    ...BLUE_MOUNTAINS,
    ...ILLAWARRA_SHOALHAVEN,
    ...HUNTER_VALLEY,
    ...NORTH_COAST,
    ...SOUTH_COAST,
    ...NEW_ENGLAND_NW,
    ...CENTRAL_WEST,
    ...RIVERINA_MURRAY,
    ...SOUTHERN_HIGHLANDS_TABLELANDS,
    ...FAR_WEST,
  ])
].sort();

export default NSW_SUBURBS;